import { useState } from "react";
import { gql, useMutation } from "@apollo/client";

export interface CertificateAuditResource {
  resourceType: string;
  id: string;
}

export const RECORD_CERTIFICATE_DOWNLOAD = gql`
  mutation RecordCertificateDownload($resourceType: String!, $id: ID!) {
    recordCertificateDownload(resourceType: $resourceType, id: $id)
  }
`;

export function useCertificateDownload(resource: CertificateAuditResource) {
  const [mutate, { loading }] = useMutation(RECORD_CERTIFICATE_DOWNLOAD);
  const [error, setError] = useState<string | null>(null);
  const record = async () => {
    setError(null);
    try {
      const result = await mutate({ variables: resource });
      if (result.data?.recordCertificateDownload !== true) throw new Error();
      return true;
    } catch {
      setError("Nedladdningen kunde inte startas. Försök igen.");
      return false;
    }
  };
  return { record, loading, error };
}
